import * as styles from './BrandMark.css'

const LOGO_DARK = 'https://res.cloudinary.com/dmxgostd9/image/upload/v1/web-assets/orchard-logo-dark.svg'

interface BrandMarkProps {
  /** Hide the "Timesheet" wordmark, showing only the Orchard logo. */
  logoOnly?: boolean
  className?: string
}

/**
 * Orchard brand lockup: the Orchard logo SVG plus the "Timesheet" product
 * wordmark. Never typeset "Orchard" as text — always use this component.
 */
export function BrandMark({ logoOnly, className }: BrandMarkProps) {
  return (
    <span className={className ? `${styles.root} ${className}` : styles.root}>
      <img className={styles.logo} src={LOGO_DARK} alt="Orchard" />
      {!logoOnly && <span className={styles.wordmark}>Timesheet</span>}
    </span>
  )
}
